$(document).ready(function(){
    objectFitImages();

    var interfaceName = $(document.body).data('interfaceName');

    $(".js-fancy").fancybox();

    $(".js-gallery").click(function(e) {
        var params = $.extend({}, $(this).data(), { _do: 'get_gallery' });
        getAJAX(params).done(function(data) {
            var photos = [];
            for (var i = 0; i < data.photos.length; i ++) {
                photos.push({
                    href: data.photos[i].src,
                    title: data.photos[i].photo_name
                });
            }
            $.fancybox.open(photos);
        });
        return false;
    });

    $(".js-video").click(function(e) {
        var params = $.extend({}, $(this).data(), { _do: 'get_video' });
        getAJAX(params).done(function(data) {
            $.fancybox.open(data.code);
        });
        return false;
    });

    $(".js-main-slider").slick({
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        dots: true,
        customPaging: function(slider, i) {    
            return '<div class="main__slider-dots"></div>';
        },
    });
    $(".js-recipe-slider").slick({
        speed: 500,
        arrows: false,
        dots: true,
        fade: true,
          cssEase: 'linear',
          dots: true,
      });

    $(".js-product-gallery").slick({
        speed: 500,
        fade: true,
        cssEase: 'linear',
        arrows: true
    });

    feedback();
    feedback({wrap:'#form_vac'});
    feedback({wrap:'#form_write'});
    feedback({wrap:'#form_order'});

    shopCities();
    shopRetails();
    contactMap();
    catalogMenu();

    $(".js-shops-slider").slick({
        speed: 500,
        arrows: true,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: $('.js-shops-slider-prev'),
        nextArrow: $('.js-shops-slider-next')
    });
    $(".js-cities-slider").slick({
        speed: 500,
        arrows: true,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: $('.js-cities-slider-prev'),
        nextArrow: $('.js-cities-slider-next')
    });

    $('.js-show-vacancy').click(function(){
        $('.allblack').fadeIn(300);
        $('.form_popup--vacancy').fadeIn(300);
    });

    $('.js-write-us').click(function(){
        $('.allblack').fadeIn(300);
        $('.form_popup--write').fadeIn(300);
    });

    $('.js-sweet-order').click(function(){
        $('.allblack').fadeIn(300);
        $('.form_popup--order').fadeIn(300);
    });

    $('.allblack, .popup_close').click(function(){
        $(this).fadeOut(150);
        $('.form_popup--vacancy').fadeOut(150);
        $('.form_popup--write').fadeOut(150);
        $('.form_popup--order').fadeOut(150);
    });
});

var isActive = 'is-active';




/*vacancy*/

var $vacancyItemTitle = $('.js-vacancy-item-title'),
    $vacancyItemTitleContent = $('.js-vacancy-item-content');


$vacancyItemTitle.click(function() {
    var i = $vacancyItemTitle.index(this);
    if ($vacancyItemTitle.eq(i).hasClass(isActive)) {
        $vacancyItemTitle.eq(i).removeClass(isActive)
    } else 
    $vacancyItemTitle.eq(i).addClass(isActive);    
    $vacancyItemTitleContent.eq(i).slideToggle(500);
});

var $mediaSwitchItem = $('.js-media-switch-item'),
$mediaContent = $('.js-media-content');

$mediaSwitchItem.click(function() {
    var i = $mediaSwitchItem.index(this);
    if ($mediaSwitchItem.eq(i).hasClass(isActive) == 0) {
        $mediaSwitchItem.removeClass(isActive).eq(i).addClass(isActive);
        $mediaContent.removeClass(isActive).eq(i).addClass(isActive);
    }
})

/*comment*/

var $commentSwitchItem = $('.js-comment-switch-item'),
        $commentBlock = $('.js-comment-block'),
        $commentItemText = $('.js-comment-item-text'),
        $commentItemMore = $('.js-comment-item-more'),
        isDown = ('is-down');

$commentSwitchItem.click(function() {
    var i = $commentSwitchItem.index(this);
    if ($commentSwitchItem.eq(i).hasClass(isActive) == 0) {
        $commentSwitchItem.removeClass(isActive).eq(i).addClass(isActive);
        $commentBlock.removeClass(isActive).eq(i).addClass(isActive);
    }
})

$commentItemMore.click(function() {
    var i = $commentItemMore.index(this);
    if ($commentItemText.eq(i).hasClass(isActive)) {
        $commentItemText.eq(i).removeClass(isActive);
        $commentItemMore.eq(i).removeClass(isDown);
    } else {
        $commentItemText.eq(i).addClass(isActive);
        $commentItemMore.eq(i).addClass(isDown);
    }
})

function commentTextMore() {
    for (var i = 0; i <= $commentItemText.length; i++) {
        var x = $commentItemText.eq(i).height();
        if (x == 135) {
            $commentItemMore.eq(i).addClass(isActive);
        } else {
            if (x < 135) {
                $commentItemMore.eq(i).removeClass(isActive).removeClass(isDown);
                $commentItemText.eq(i).removeClass(isActive);
            }
        }
    }
}    

$(window).on('resize', commentTextMore).on('load', commentTextMore);

/*shops*/

function shopCities(){
    var $links = $('.shops__cities-item'),
        $lists = $('.shops__block-address'),
        $items = $('.shops__address-item'),
        $map = $('.shops__map');

    var myMap;

    if (!window.ymaps) return;

    ymaps.ready(initMap);

    function showCity(id) {
        $links.removeClass('is-active').filter("[data-city_id='"+id+"']").addClass('is-active');
        $lists.hide().filter("[data-city_id='"+id+"']").show();

        var $list = $lists.filter("[data-city_id='"+id+"']");

        if (!$list.data('placemarks')) {
            var placemarks = [];
            var $items = $list.find('.shops__address-item');
            for (var i = 0; i < $items.length; i ++) {
                var $item = $items.eq(i);

                var coords = $item.data('coords').split(/[^0-9.]+/);

                var placemark = new ymaps.Placemark(coords, {
                    balloonContentHeader: $item.data('name'),
                    balloonContentBody: "<p>"+$item.data('address')+"</p><p>"+$item.data('phone')+"</p>",
                    iconContent: ""
                }, {
                    balloonCloseButton: true,
                    hideIconOnBalloonOpen: true,
                    iconLayout: 'default#image',
                    iconImageHref: '/i/icons/map_marker.png',
                    iconImageSize: [51, 51]
                });
                placemarks.push(placemark);
            }
            $list.data('placemarks', placemarks);
        }

        var marks = $list.data('placemarks');

        myMap.geoObjects.removeAll();
        for (var i = 0; i < marks.length; i ++) {
            myMap.geoObjects.add(marks[i]);
        }

        myMap.setBounds(myMap.geoObjects.getBounds());
    }
    function showItem(coords) {
        myMap.setCenter(coords, 15, { checkZoomRange: true });
    }
    function initMap() {
        myMap = new ymaps.Map($map.get(0), {
            center: [54.235279, 45.085955],
            zoom: 6
        });
        myMap.behaviors.disable('multiTouch');
        myMap.behaviors.disable('drag');

        showCity($links.eq(0).data('city_id'));
    }

    $links.click(function() {
        showCity($(this).data('city_id'));
        return false;
    });
    $items.click(function() {
        showItem($(this).data('coords').split(/[^0-9.]+/));
        return false;
    });
}

function shopRetails() {
    $('.js-shops-slider-item').click(function() {
        $.fancybox.open({
            content: $(this).data('content')
        });
        return false;
    });
}


/*contacts*/

var $contactsSubmenuItem = $('.js-contacts-submenu-item'),
    $contactsItemBtnImg = $('.js-contacts-item-btn-img'),
    $contactsItemBlock = $('.js-contacts-item-block');

/*contacts submenu click*/

$contactsSubmenuItem.click (function() {
    var i = $contactsSubmenuItem.index(this);

    if (($contactsSubmenuItem.eq(i)).hasClass(isActive)) {
        $contactsSubmenuItem.eq(i).removeClass(isActive);
        $contactsItemBlock.slideUp(500);
        $contactsItemBtnImg.eq(i).removeClass(isActive);
    }
    else {
        $contactsSubmenuItem.removeClass(isActive);
        $contactsItemBlock.slideUp(500).eq(i).slideDown(500,  function() {
            var $container = $('.contacts-item__block'),
            $scrollTo = $('.contacts-item__employees-btn').eq(i);
            $container.stop().animate({
                scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
            }, 300);
            
        });
        $contactsSubmenuItem.eq(i).addClass(isActive);
        $contactsItemBtnImg.removeClass(isActive).eq(i).addClass(isActive);
    }
    return(false);
});

/*contacts btn click*/

$contactsItemBtnImg.click (function() {
    var i = $contactsItemBtnImg.index(this);
    if (($contactsSubmenuItem.eq(i)).hasClass(isActive)) {
        $contactsSubmenuItem.eq(i).removeClass(isActive);
        $contactsItemBlock.slideUp(500);
        $contactsItemBtnImg.eq(i).removeClass(isActive);
    }
    else {
        $contactsSubmenuItem.removeClass(isActive);
        $contactsItemBlock.slideUp(500).eq(i).slideDown(500,  function() {
            var $container = $('.contacts-item__block'),
            $scrollTo = $('.contacts-item__employees-btn').eq(i);
            $container.stop().animate({
                scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
            }, 500);
        });
        $contactsSubmenuItem.eq(i).addClass(isActive);
        $contactsItemBtnImg.removeClass(isActive).eq(i).addClass(isActive);
    }
});

/*contacts map*/

function contactMap() {
    var $contactsMap = $('.js-contacts-map'),
        $contactsMapBlock = $('.js-contacts-map-block'),
        $mapSectionBtnOpen = $('.js-contacts-map-btn-open'),
        $mapSectionBtnClose = $('.js-contacts-map-btn-close'),
        $contactsContainer = $('.js-contacts-container');

    var windowHeight,
        containerHeight,
        containerOffset;

    function openMap() {
        $contactsMap.addClass(isActive);
    }

    function closeMap() {
        $contactsMap.removeClass(isActive);
    }

    function fadeInMapBlock() {
        $contactsMapBlock.fadeTo(500, .9);
    }

    function fadeInBtnClose() {
        $mapSectionBtnClose.fadeIn(500);
    }

    $mapSectionBtnOpen.click(function() {
        $contactsMapBlock.fadeOut(500);
        setTimeout(openMap, 500);
        setTimeout(fadeInBtnClose, 1000);
    });

    $mapSectionBtnClose.click(function() {
        $mapSectionBtnClose.fadeOut(500);
        setTimeout(closeMap, 500);
        setTimeout(fadeInMapBlock, 1000);
    });

    function resize() {
        windowHeight = Math.min($(window).height(), $contactsContainer.outerHeight());
        containerOffset = $contactsContainer.offset().top;
        containerHeight = $contactsContainer.outerHeight();

        $contactsMap.css({ height: windowHeight });

        scroll();
    }
    function scroll() {
        var scrollTop = $(window).scrollTop();

        var delta = scrollTop - containerOffset;
        if (delta < 0) {
            delta = 0;
        } else if (delta > containerHeight - windowHeight) {
            delta = containerHeight - windowHeight;
        }

        $contactsMap.css({ marginTop: delta });
    }

    if ($contactsContainer.length && $contactsMap.length) {
        $(window).on('resize', resize).on('scroll', scroll);
        resize();
    }
}

function catalogMenu() {
    var $container = $(".js-catalog-container"),
        $menu = $(".js-catalog-menu"),
        $links = $(".js-catalog-link"),
        $items = $(".js-catalog-item");

    var windowHeight,
        containerHeight,
        containerOffset,
        menuHeight;

    function resize() {
        windowHeight = $(window).height();
        containerOffset = $container.offset().top;
        containerHeight = $container.outerHeight();
        menuHeight = $menu.outerHeight();

        for (var i = 0; i < $items.length; i ++) {
            var $item = $items.eq(i);

            $item.data({ offset: $item.offset().top, height: $item.outerHeight() });
        }

        scroll();
    }
    function scroll() {
        var scrollTop = $(window).scrollTop();

        var delta = scrollTop - containerOffset;
        if (delta < 0) {
            delta = 0;
        } else if (delta > containerHeight - windowHeight) {
            delta = containerHeight - windowHeight;
        }

        $menu.css({ marginTop: delta });

        $links.removeClass('is-active');

        for (var i = 0; i < $items.length; i ++) {
            var $item = $items.eq(i);

            if ($item.data('offset') + $item.data('height') > scrollTop + windowHeight/2) {
                if ($item.data('offset') <= scrollTop + windowHeight/2) {
                    $links.eq(i).addClass('is-active');
                    break;
                }
            }
        }
    }

    if ($container.length && $menu.length) {
        $links.on('click', function(e) {
            var anchor = this.getAttribute('href');
            $([document.documentElement, document.body]).animate({ scrollTop: $items.filter(anchor).offset().top }, { duration: 300 });
            return false;
        });

        $(window).on('resize', resize).on('scroll', scroll).on('load', resize);
        resize();
    }
}
